<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Fix Directors</h2>

  <div mat-dialog-content [formGroup]="form">
    <ngx-spinner></ngx-spinner>

    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSource" class="board-table" formArrayName="rows"
             [hidden]="dataSource.data.length === 0">

        <ng-container matColumnDef="index">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index" class="cell-index" (click)="toggleRowHighlight(row)">{{ i + 1 }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let row">
            <span class="name-cell">
              <a [routerLink]="['/directors/edit', row.directorId]" target="_blank" rel="noopener"
                 class="director-link-btn" title="Edit director" (click)="$event.stopPropagation()">
                <mat-icon>open_in_new</mat-icon>
              </a>
              {{ row.directorFullName }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let row" class="cell-center">
            {{ row.isExecutive ? 'Executive' : 'Board' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="occupation">
          <th mat-header-cell *matHeaderCellDef>Occupation</th>
          <td mat-cell *matCellDef="let row">{{ occupationName(row.occupationId) }}</td>
        </ng-container>

        <ng-container matColumnDef="years">
          <th mat-header-cell *matHeaderCellDef>Years</th>
          <td mat-cell *matCellDef="let row" class="cell-center">
            {{ row.yearFrom }} – {{ row.yearTo }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ceoTurnover">
          <th mat-header-cell *matHeaderCellDef>CEO Turnover</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <select formControlName="ceoTurnoverReasonId" class="ht-select">
              <option value=""></option>
              @for (reason of ceoTurnoverReasons; track reason.id) {
                <option [value]="reason.id" [title]="reason.name">{{ reason.name }}</option>
              }
            </select>
          </td>
        </ng-container>

        <ng-container matColumnDef="ceoHireDate">
          <th mat-header-cell *matHeaderCellDef>CEO Hire Date</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" formControlName="ceoHireDate" class="ht-input ht-date-input" maxlength="10"
                   (focus)="onDateFocus($event)" (blur)="onDateBlur($event)" (input)="onDateInput($event)">
          </td>
        </ng-container>

        <ng-container matColumnDef="ceoEndDate">
          <th mat-header-cell *matHeaderCellDef>CEO End Date</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" formControlName="ceoEndDate" class="ht-input ht-date-input" maxlength="10"
                   (focus)="onDateFocus($event)" (blur)="onDateBlur($event)" (input)="onDateInput($event)">
          </td>
        </ng-container>

        <ng-container matColumnDef="hireDate">
          <th mat-header-cell *matHeaderCellDef>Hire Date</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" formControlName="hireDate" class="ht-input ht-date-input" maxlength="10"
                   (focus)="onDateFocus($event)" (blur)="onDateBlur($event)" (input)="onDateInput($event)">
          </td>
        </ng-container>

        <ng-container matColumnDef="endDate">
          <th mat-header-cell *matHeaderCellDef>End Date</th>
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <input type="text" formControlName="endDate" class="ht-input ht-date-input" maxlength="10"
                   (focus)="onDateFocus($event)" (blur)="onDateBlur($event)" (input)="onDateInput($event)">
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.row-highlighted]="row.highlighted"></tr>
      </table>

      @if (dataSource.data.length === 0) {
        <div class="empty-state">No director periods found.</div>
      }
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button color="primary" type="button" [disabled]="!hasChanges" (click)="onSave()">
      <mat-icon>save</mat-icon>
      Save
    </button>
    <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onClose()">
      <mat-icon>clear</mat-icon>
      Close
    </button>
  </div>
</div>
